module.exports = angular.module('website-engagement-ctrl', [])
    .controller('websiteEngagementCtrl',['$rootScope', '$scope', 'canvasService', '$interval', function ($rootScope, $scope, canvasService, $interval) {
        if ($scope.connections.length !== undefined) {
            let now = new Date();

            //Start new Connection obj
            $scope.connections = {
                id:'entry_' + now.getTime(),
                data: {
                    source: 'any-tracked-page',
                    specificUrl: ''
                },
            };
        }

        let stop, intents = 0;

        $scope.$parent.connections = $scope.connections;

        $scope.specificUrlOptions = [
            {
                value: 'any-tracked-page',
                message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
            },
            {
                value: 'is-url',
                message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
            },
            {
                value: 'contains-url',
                message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
            },
            {
                value: 'doesnotcontain-url',
                message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
            },
            {
                value: 'startswith-url',
                message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
            },
            {
                value: 'endswith-url',
                message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
            },
            {
                value: 'wildcardmatch-url',
                message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
            }
        ];

        $scope.$watch('connections.data.source', function (newVal) {
            if (newVal === 'is-url') {
                $scope.specificUrlPlaceholder = $scope.translate('commons.url.is');
            } else if (newVal === 'contains-url' || newVal === 'doesnotcontain-url') {
                $scope.specificUrlPlaceholder = $scope.translate('commons.url.contains');
            } else if (newVal === 'startswith-url') {
                $scope.specificUrlPlaceholder = $scope.translate('commons.url.starts');
            } else if (newVal === 'endswith-url') {
                $scope.specificUrlPlaceholder = $scope.translate('commons.url.ends');
            } else if (newVal === 'wildcardmatch-url') {
                $scope.specificUrlPlaceholder = $scope.translate('commons.url.wildcard');
            }
        });

        $scope.testUrl = function() {
            if ($scope.connections.data.specificUrl) {
                $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.checking');
                $scope.trackingTestClass = 'checking-url';
                let testUrl = $scope.connections.data.specificUrl + '?apTestApi=true&url=' + encodeURIComponent($scope.connections.data.specificUrl);
                if(/^http:\/\//i.test(testUrl)) {
                    document.getElementsByName('testSiteIFrame')[0].src = testUrl;
                } else {
                    window.open(testUrl , '_blank');
                }
                stop = $interval(() => {
                    canvasService.testTracker($scope.connections.data.specificUrl).then(function (result) {
                        if(result.data.TestTrackerInformation.IsInstalled) {
                            $interval.cancel(stop);
                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.confirm');
                            $scope.trackingTestClass = 'url-confirm';
                            intents = 0;
                        } else if(intents >= 4) {
                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                            $scope.trackingTestClass = 'url-fail';
                            $interval.cancel(stop);
                            intents = 0;
                        }
                        intents ++;
                    }).catch(function() {
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                        $scope.trackingTestClass = 'url-fail';
                        $interval.cancel(stop);
                        intents = 0;
                    });
                }, 2000);
            } else {
                $scope.$emit('errorMsg', $scope.translate('canvas.entry.websiteEngagement.url.error'), 'error');
            }
        };

        $scope.$watch('connections.data.specificUrl', function (url) {
            if (url && ($scope.connections.data.source === 'is-url' || $scope.connections.data.source === 'wildcardmatch-url')) {
                var reg;

                if ($scope.connections.data.source === 'is-url') {
                    reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
                } else {
                    reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+\/\*$/;
                }

                if (!reg.test(url)) {
                    $scope.$parent.specificUrlError = true;
                } else {
                    $scope.$parent.specificUrlError = false;
                }
            } else {
                $scope.$parent.specificUrlError = false;
            }
        });

        $scope.displayTrackerModal = () => {
            $scope.$parent.showTriggerPanelModal = false;
            $rootScope.$emit('displayTrackerModal');
        };

        // Show web site engagement when user copy the code
        $rootScope.$on('showWebSiteEngagement', function () {
            $scope.$parent.showTriggerPanelModal = true;
        });

        $scope.changeUrlState = () => {
            if ($scope.connections.data.source !== 'is-url' || $scope.connections.data.source !== 'wildcardmatch-url') {
                $scope.$parent.specificUrlError = false;
            }
        };

    }]);



// WEBPACK FOOTER //
// ./app/controllers/triggerPanel/webSiteEngagementCtrl.js